var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"spinner"},[_c('cube-of-cubes',{staticClass:"cubes",attrs:{"mod":_vm.mod,"step":_vm.step,"size":"50"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }